import axiosInstance from '../api/axios';

/**
 * Client's Tradier account history (qfaaOperator only).
 * Resolves to { data } on success or { error, code, accountId } on a handled failure.
 */
export async function fetchAdminTradierHistory({ userId, start, end }) {
  try {
    const res = await axiosInstance.get('/admin_tradier_history', {
      params: { userId, start, end },
      // Large accounts page through tens of thousands of broker events.
      timeout: 300000,
    });
    return { data: res.data?.data };
  } catch (err) {
    const body = err?.response?.data || {};
    return {
      error: body.error || err?.message || 'Failed to load Tradier history',
      code: body.code || null,
      accountId: body.accountId || null,
    };
  }
}
